import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { Payment, RecordPaymentRequest } from '../types';

export const paymentService = {
  getAll: async (): Promise<Payment[]> => {
    const response = await apiClient.get<Payment[]>(API_ENDPOINTS.PAYMENTS.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<Payment> => {
    const response = await apiClient.get<Payment>(API_ENDPOINTS.PAYMENTS.BY_ID(id));
    return response.data;
  },

  getByInvoice: async (invoiceId: number): Promise<Payment[]> => {
    const response = await apiClient.get<Payment[]>(
      API_ENDPOINTS.PAYMENTS.BY_INVOICE(invoiceId)
    );
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string): Promise<Payment[]> => {
    const response = await apiClient.get<Payment[]>(
      API_ENDPOINTS.PAYMENTS.DATE_RANGE,
      { params: { startDate, endDate } }
    );
    return response.data;
  },

  record: async (data: RecordPaymentRequest): Promise<Payment> => {
    const response = await apiClient.post<Payment>(API_ENDPOINTS.PAYMENTS.BASE, data);
    return response.data;
  },

  verify: async (id: number): Promise<Payment> => {
    const response = await apiClient.post<Payment>(API_ENDPOINTS.PAYMENTS.VERIFY(id));
    return response.data;
  },

  cancel: async (id: number, reason: string): Promise<Payment> => {
    const response = await apiClient.post<Payment>(
      API_ENDPOINTS.PAYMENTS.CANCEL(id),
      null,
      { params: { reason } }
    );
    return response.data;
  },
};
